// Copyright (c) 2026 Solartek LLC. All rights reserved.
import { z } from 'zod';
import { paginationQuerySchema, uuidSchema } from '../common.js';
/**
 * The monthly shift roster (HR portal Prompt 6b, Finance ATT-105): every employee in the caller's branch scope over one month,
 * a cell per day with the shift the ENGINE resolves (most specific assignment, rotation pattern, else the organisation's default
 * shift), "Off" on weekly off / pattern off days, the holiday and approved leave. Read-only; shift.view.
 */
export const shiftRosterQuerySchema = paginationQuerySchema.extend({
    month: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/, 'Use YYYY-MM'),
    branchId: uuidSchema.optional(),
    departmentId: uuidSchema.optional(),
    search: z.string().trim().max(100).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).default(50),
});
//# sourceMappingURL=roster.js.map